import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createVNode as _createVNode, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, withCtx as _withCtx, resolveDirective as _resolveDirective, withDirectives as _withDirectives, renderSlot as _renderSlot } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = {
  key: 0,
  class: "flex justify-between items-center p-4"
}
const _hoisted_3 = { class: "flex items-center gap-3" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "hidden md:flex" }, null, -1)
const _hoisted_5 = { class: "flex md:hidden" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("p", { class: "text-gray-400 text-center p-3" }, /*#__PURE__*/_toDisplayString("Dados não encontrados"), -1)
const _hoisted_7 = ["title"]
const _hoisted_8 = ["src"]
const _hoisted_9 = {
  key: 1,
  class: "md:flex items-center gap-3 hidden"
}
const _hoisted_10 = ["onClick"]
const _hoisted_11 = ["onClick"]
const _hoisted_12 = { key: 0 }
const _hoisted_13 = {
  key: 0,
  class: "flex justify-center items-center"
}
const _hoisted_14 = { key: 0 }
const _hoisted_15 = { key: 1 }
const _hoisted_16 = { key: 1 }
const _hoisted_17 = {
  key: 0,
  class: "flex justify-center items-center"
}
const _hoisted_18 = { key: 0 }
const _hoisted_19 = ["title"]
const _hoisted_20 = {
  key: 0,
  class: "flex justify-center items-center gap-4"
}
const _hoisted_21 = { key: 0 }
const _hoisted_22 = { key: 0 }
const _hoisted_23 = {
  key: 1,
  class: "flex items-center justify-center flex-wrap gap-4"
}
const _hoisted_24 = {
  key: 1,
  class: "flex justify-end items-center"
}
const _hoisted_25 = /*#__PURE__*/_createElementVNode("p", { class: "mb-2 text-sm font-bold" }, "Pesquisar por:", -1)
const _hoisted_26 = { class: "flex flex-row gap-2" }
const _hoisted_27 = { class: "w-100" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_Column = _resolveComponent("Column")!
  const _component_DataTable = _resolveComponent("DataTable")!
  const _component_Paginator = _resolveComponent("Paginator")!
  const _component_OverlayPanel = _resolveComponent("OverlayPanel")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.filters)
      ? (_openBlock(), _createElementBlock("section", _hoisted_1, [
          (_ctx.filters.isCleareable)
            ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                _createElementVNode("div", _hoisted_3, [
                  (_ctx.filters.isCleareable)
                    ? (_openBlock(), _createBlock(_component_Button, {
                        key: 0,
                        label: "Limpar",
                        icon: "pi pi-times",
                        class: "btn-outline p-button-sm",
                        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.onClearFilter()))
                      }))
                    : _createCommentVNode("", true)
                ]),
                _hoisted_4,
                _createElementVNode("div", _hoisted_5, [
                  _createVNode(_component_Button, {
                    class: "btn-primary p-button-sm",
                    icon: "pi pi-plus"
                  })
                ])
              ]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    _createVNode(_component_DataTable, {
      value: _ctx.slotData,
      loading: _ctx.loading,
      showGridlines: ""
    }, {
      empty: _withCtx(() => [
        _hoisted_6
      ]),
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.columns, (col, i) => {
          return (_openBlock(), _createBlock(_component_Column, {
            field: col.value,
            header: col.name,
            key: i,
            class: "table-style",
            headerClass: "custom-header"
          }, {
            header: _withCtx(() => [
              (col?.image)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 0,
                    class: "md:flex items-center justify-center gap-3 hidden bg-white p-1 rounded-md",
                    title: col.name
                  }, [
                    (col.iconName)
                      ? (_openBlock(), _createBlock(_component_v_icon, {
                          key: 0,
                          name: col.iconName,
                          class: "text-h-primary-500"
                        }, null, 8, ["name"]))
                      : (_openBlock(), _createElementBlock("img", {
                          key: 1,
                          src: col.imageName,
                          alt: "coluna",
                          class: "w-[80%] min-w[100px]"
                        }, null, 8, _hoisted_8))
                  ], 8, _hoisted_7))
                : (_openBlock(), _createElementBlock("div", _hoisted_9, [
                    _createElementVNode("span", null, _toDisplayString(col.name), 1),
                    (_ctx.filters && col.filter && !col?.order)
                      ? (_openBlock(), _createElementBlock("i", {
                          key: 0,
                          class: _normalizeClass(`pi pi-filter text-white cursor-pointer hover:scale-125`),
                          onClick: ($event: any) => (_ctx.onToggleFilter($event, col))
                        }, null, 8, _hoisted_10))
                      : _createCommentVNode("", true),
                    (_ctx.filters && col.filter && col?.order)
                      ? (_openBlock(), _createElementBlock("i", {
                          key: 1,
                          class: _normalizeClass(`pi pi-sort-alt text-white cursor-pointer hover:scale-125`),
                          onClick: ($event: any) => (_ctx.onSortFilter(col))
                        }, null, 8, _hoisted_11))
                      : _createCommentVNode("", true)
                  ]))
            ]),
            body: _withCtx((slotProps) => [
              (Array.isArray(slotProps.data[col.value]))
                ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(slotProps.data[col.value], (item, i) => {
                      return (_openBlock(), _createElementBlock("div", { key: i }, [
                        (item?.name)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                              (!item?.class)
                                ? (_openBlock(), _createElementBlock("p", _hoisted_14, _toDisplayString(item ?? " - "), 1))
                                : (_openBlock(), _createElementBlock("p", {
                                    key: 1,
                                    class: _normalizeClass(`${item?.class} py-1 px-2 rounded-xl text-xs  w-100 mt-1`)
                                  }, _toDisplayString(item?.name ?? " - "), 3))
                            ]))
                          : (_openBlock(), _createElementBlock("p", _hoisted_15, _toDisplayString(item ?? " - "), 1))
                      ]))
                    }), 128))
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_16, [
                    (slotProps.data[col.value]?.name)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                          (!slotProps.data[col.value]?.class)
                            ? (_openBlock(), _createElementBlock("p", _hoisted_18, [
                                (slotProps.data[col.value]?.icon)
                                  ? (_openBlock(), _createBlock(_component_v_icon, {
                                      key: 0,
                                      name: slotProps.data[col.value]?.icon,
                                      scale: slotProps.data[col.value]?.iconSize ?? 0.6
                                    }, null, 8, ["name", "scale"]))
                                  : _createCommentVNode("", true),
                                _createTextVNode(" " + _toDisplayString(slotProps.data[col.value]?.name ?? " - "), 1)
                              ]))
                            : (_openBlock(), _createElementBlock("p", {
                                key: 1,
                                class: _normalizeClass(`${
                slotProps.data[col.value]?.class
              } py-1 px-2 rounded-md text-xs  w-100`)
                              }, [
                                (slotProps.data[col.value]?.icon)
                                  ? (_openBlock(), _createBlock(_component_v_icon, {
                                      key: 0,
                                      name: slotProps.data[col.value]?.icon,
                                      scale: slotProps.data[col.value]?.iconSize ?? 0.6
                                    }, null, 8, ["name", "scale"]))
                                  : _createCommentVNode("", true),
                                _createTextVNode(" " + _toDisplayString(slotProps.data[col.value]?.name ?? " - "), 1)
                              ], 2))
                        ]))
                      : (_openBlock(), _createElementBlock("p", {
                          key: 1,
                          class: "line-clamp-2",
                          title: 
              slotProps.data[col.completeValue] ??
              slotProps.data[col.value] ??
              '-'
            
                        }, _toDisplayString(slotProps.data[col.value] ?? " - "), 9, _hoisted_19))
                  ]))
            ]),
            _: 2
          }, 1032, ["field", "header"]))
        }), 128)),
        (_ctx.hasActions)
          ? (_openBlock(), _createBlock(_component_Column, {
              key: 0,
              header: _ctx.actionsTitle,
              class: "sm:max-w-[16rem]"
            }, {
              body: _withCtx((slotProps) => [
                (_ctx.actions?.length !== 0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.actions, (action, i) => {
                        return (_openBlock(), _createElementBlock("div", { key: i }, [
                          _withDirectives((_openBlock(), _createBlock(_component_Button, {
                            class: _normalizeClass(`flex items-center gap-2 transition-all p-button-sm ${
                action.style
              } cursor-pointer ${action.icon ? 'hover:scale-110' : ''}`),
                            onClick: ($event: any) => (_ctx.onEvent(slotProps.data, action.type)),
                            disabled: action.disabled
                          }, {
                            default: _withCtx(() => [
                              (action.title)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_21, _toDisplayString(action.title), 1))
                                : _createCommentVNode("", true),
                              (action.icon)
                                ? (_openBlock(), _createBlock(_component_v_icon, {
                                    key: 1,
                                    name: action.icon
                                  }, null, 8, ["name"]))
                                : _createCommentVNode("", true)
                            ]),
                            _: 2
                          }, 1032, ["class", "onClick", "disabled"])), [
                            [_directive_tooltip, `${action.tooltip ?? ''}`]
                          ])
                        ]))
                      }), 128)),
                      (_ctx.hasStatus)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                            (
                slotProps.data.status?.value == 'INACTIVATED' ||
                slotProps.data.status?.value == 'INACTIVE'
              )
                              ? _withDirectives((_openBlock(), _createBlock(_component_Button, {
                                  key: 0,
                                  class: "btn-simple"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_icon, {
                                      name: "hi-solid-minus-circle",
                                      class: "text-gray-400 cursor-pointer hover:scale-125",
                                      onClick: ($event: any) => (_ctx.onChangeStatus(slotProps.data))
                                    }, null, 8, ["onClick"])
                                  ]),
                                  _: 2
                                }, 1024)), [
                                  [_directive_tooltip, 'Ativar']
                                ])
                              : _createCommentVNode("", true),
                            (
                slotProps.data.status?.value == 'ACTIVATED' ||
                slotProps.data.status?.value == 'ACTIVE'
              )
                              ? _withDirectives((_openBlock(), _createBlock(_component_Button, {
                                  key: 1,
                                  class: "btn-simple"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_icon, {
                                      name: "hi-solid-minus-circle",
                                      class: "text-h-error-400 cursor-pointer hover:scale-125",
                                      onClick: ($event: any) => (_ctx.onChangeStatus(slotProps.data))
                                    }, null, 8, ["onClick"])
                                  ]),
                                  _: 2
                                }, 1024)), [
                                  [_directive_tooltip, 'Desativar']
                                ])
                              : _createCommentVNode("", true),
                            (slotProps.data.status?.value == 'BLOCKED')
                              ? _withDirectives((_openBlock(), _createBlock(_component_Button, {
                                  key: 2,
                                  class: "btn-simple"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_icon, {
                                      name: "hi-solid-lock-open",
                                      class: "text-h-secondary-700 cursor-pointer hover:scale-125",
                                      onClick: ($event: any) => (_ctx.onChangeStatus(slotProps.data))
                                    }, null, 8, ["onClick"])
                                  ]),
                                  _: 2
                                }, 1024)), [
                                  [_directive_tooltip, 'Desbloquear']
                                ])
                              : _createCommentVNode("", true),
                            (slotProps.data.status?.value == 'WAITING_ACTIVATION')
                              ? (_openBlock(), _createBlock(_component_v_icon, {
                                  key: 3,
                                  name: "hi-solid-minus-circle",
                                  class: "text-gray-400 cursor-default"
                                }))
                              : _createCommentVNode("", true)
                          ]))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.customActions)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                      _renderSlot(_ctx.$slots, "actions", { columnProps: slotProps })
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _: 3
            }, 8, ["header"]))
          : _createCommentVNode("", true)
      ]),
      _: 3
    }, 8, ["value", "loading"]),
    (_ctx.params?.total > _ctx.params?.size)
      ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
          _createVNode(_component_Paginator, {
            rows: _ctx.params?.size,
            totalRecords: _ctx.params?.total,
            onPage: _cache[1] || (_cache[1] = ($event: any) => (_ctx.onPaginate($event))),
            rowsPerPageOptions: [_ctx.params?.size, 20, 30]
          }, null, 8, ["rows", "totalRecords", "rowsPerPageOptions"])
        ]))
      : _createCommentVNode("", true),
    _createVNode(_component_OverlayPanel, {
      ref: "filter",
      style: {"min-width":"200px"}
    }, {
      default: _withCtx(() => [
        _createElementVNode("section", null, [
          _hoisted_25,
          _createElementVNode("div", _hoisted_26, [
            _renderSlot(_ctx.$slots, "filters"),
            _createElementVNode("div", _hoisted_27, [
              _createVNode(_component_Button, {
                icon: "pi pi-search",
                class: "btn-primary",
                onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.onFilter($event)))
              })
            ])
          ])
        ])
      ]),
      _: 3
    }, 512)
  ], 64))
}